import {createRoot, hydrateRoot} from 'react-dom/client';
import DataRoom from '../pages/DataRoom/DataRoom'
import "../index.css";
import "../pages/DataRoom/DataRoom.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<DataRoom {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <DataRoom {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).DataRoomVC = {mount, hydrate, unmount}